let env = 'production';
if (window.location.origin.includes('gloat-staging')) {
  env = 'staging';
} else if (window.location.origin.includes('gloat-dev')) {
  env = 'development';
} else if (window.location.origin.includes('localhost')) {
  env = 'local';
}

import development from './development';
import staging from './staging';
import production from './production';
import local from './local';

export type AppConfigStructure = {
  name: 'development' | 'staging' | 'integration' | 'production' | 'local';

  splitFeatureFlagSystem?: {
    isOn: boolean;
    key: string;
  };
  intercom: {
    isOn: boolean;
    appID?: string;
  };
  sentry: {
    isOn: boolean;
    DSN?: string;
  };
  fullStory: {
    isOn: boolean;
  };

  isStaffModeAllowed?: boolean;

  eventTracker: {
    isOn: boolean;
  };

  identityEndpointSlug?: 'identity' | 'identity.gloat-dev';

  features: Record<string, boolean>;
};

const configs: { [key: string]: AppConfigStructure } = {
  local,
  development,
  staging,
  production,
};

const config = configs[env] || development;

export default config;
